import { db } from '../firebase/firebase';
//Actions
// const startDate = new Date('2025-12-22T06:00:00Z');
// const endDate = new Date('2025-12-23T06:00:00Z');

export function logGet(method, clan) {
  return async (dispatch, getState) => {
    const place = getState().place.uid;
    const log = [];
    let logRef = db
      .collection('log')
      .where('place', '==', place)
      .where('method', '==', method)
      // .where('date', '>=', startDate)
      // .where('date', '<=', endDate)
      .orderBy('date', 'desc')
      .limit(2000);
    logRef = clan ? logRef.where('clan', '==', clan) : logRef;
    logRef.onSnapshot((querySnap) => {
      querySnap.docChanges().forEach(({ doc, type }) => {
        const data = doc.data();
        if (type === 'added') {
          log.push({
            ...data,
            date: data.date.seconds * 1000,
          });
        }
      });
      return dispatch(logSet(log, method));
    });
  };
}

export function logSet(log, method) {
  return {
    type: 'LOG_SET',
    log,
    method,
  };
}
